import {TakipDurumu} from "@/enum/TakipDurumu";

export class TakipEtiketiEntity {
    id!: number;
    isim!: string;
    takip_durumu!: TakipDurumu;
}